<template lang="pug">
Loading(v-if="showLoading")
Error(v-else-if="showError")
.tw-card-active-page(v-else)
  img.img-peat(:src='image' v-for='image in images' :key='image')
  .button(@click='copyHaCommand' v-flash="{scale:0.9,boom:true}") 点击按钮自动复制哈口令 打开哈啰APP激活使用
</template>

<script>
import { getDynamicHaCommand, getHaCommandPageInfo } from '@/api/tiktokSign';
import { getSystemCode } from '@/utils/systemCode';
import { getTokenAndLocation, copyText, getTokenAndKey } from '@/utils';
import Toast from '@/components/toast';
import config from '@/const/config';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { ParamsUtil } from '@/utils/params';
import Loading from './components/loading';

import {
  SCENE_TYPE, ADSOURCE_TYPE, PAGE_INFO_SCENE, SUB_SCENE_MAP,
} from './const';
import Error from './components/error';

// 不同环境的子场景 ⚠️⚠️⚠️⚠️⚠️⚠️⚠️每个环境的子场景不一样，需要根据环境来设置
// 子场景获取参考文档：https://hellobike.yuque.com/wx01fq/newbie/al6yk24ztbvzt782?singleDoc#

export default {
  name: 'TwCardActivePage',
  components: {
    Loading,
    Error,
  },
  data() {
    return {
      // 哈口令
      haCode: '',
      // 哈口令的跳转链接
      shareCode: '',
      // 1单车 2助力车
      businessType: '1',
      // 链接参数
      showLoading: true,
      showError: false,
      images: ['https://m.hellobike.com/8ce3775c43.png', 'https://m.hellobike.com/c292137a9d.png'],
    };
  },
  computed: {
    sceneType() {
      const { adsource } = this.$route.query;
      if (adsource === ADSOURCE_TYPE.STUDENT_CENTER) {
        return SCENE_TYPE.STUDENT_CENTER;
      }
      if (adsource === ADSOURCE_TYPE.SWAP_BATTERY) {
        return SCENE_TYPE.SWAP_BATTERY;
      }
      return SCENE_TYPE.TWO_WHEEL;
    },
    subSceneMap() {
      const { adsource } = this.$route.query;
      if (adsource === ADSOURCE_TYPE.STUDENT_CENTER) {
        return SUB_SCENE_MAP.STUDENT_CENTER;
      }
      if (adsource === ADSOURCE_TYPE.SWAP_BATTERY) {
        return SUB_SCENE_MAP.SWAP_BATTERY;
      }
      return SUB_SCENE_MAP.TWO_WHEEL;
    },
  },
  mounted() {
    this.init();
    // 根据场景上报页面曝光
    this.reportPageView();
    // 根据场景上报按钮模块曝光
    this.reportModuleExpose();
  },
  beforeDestroy() {
    // 根据场景上报页面退出
    this.reportPageViewOut();
  },
  methods: {
    /**
     * 上报页面曝光 - 根据业务场景选择上报方式
     */
    reportPageView() {
      switch (this.sceneType) {
        // case SCENE_TYPE.STUDENT_CENTER:
        // 学生中心场景埋点
        // TODO: 待学生中心埋点需求确认后补充
        // break;
        default:
          // 两轮场景埋点（默认）
          UBT.pageView({
            pageId: 'platform_wxtrans_command',
            categoryId: 'platform',
            businessInfo: {
              showtype: this.businessType,
              attributeId: this.attributeId,
            },
          });
          break;
      }
    },

    /**
     * 上报页面退出 - 根据业务场景选择上报方式
     */
    reportPageViewOut() {
      switch (this.sceneType) {
        // case SCENE_TYPE.STUDENT_CENTER:
        // 学生中心场景埋点
        // TODO: 待学生中心埋点需求确认后补充
        // break;
        default:
          // 两轮场景埋点（默认）
          UBT.pageViewOut({
            pageId: 'platform_wxtrans_command',
            categoryId: 'platform',
            businessInfo: {
              showtype: this.businessType,
              attributeId: this.attributeId,
            },
          });
          break;
      }
    },

    /**
     * 上报模块曝光 - 根据业务场景选择上报方式
     */
    reportModuleExpose() {
      switch (this.sceneType) {
        // case SCENE_TYPE.STUDENT_CENTER:
        // 学生中心场景埋点
        // TODO: 待学生中心埋点需求确认后补充
        // break;
        default:
          // 两轮场景埋点（默认）
          UBT.moduleExpose({
            pageId: 'platform_wxtrans_command',
            categoryId: 'platform',
            moduleId: 'platform_wxtrans_command_buutun',
            contentId: 'platform_wxtrans_command_buutun',
            exposureTimes: 1,
            businessInfo: {
              card_guid: this.cardGuid,
              showtype: this.businessType,
            },
          });
          break;
      }
    },

    /**
     * 上报按钮点击 - 根据业务场景选择上报方式
     */
    reportButtonClick() {
      switch (this.sceneType) {
        // case SCENE_TYPE.STUDENT_CENTER:
        // 学生中心场景埋点
        // TODO: 待学生中心埋点需求确认后补充
        // break;
        default:
          // 两轮场景埋点（默认）
          UBT.clickButton({
            pageId: 'platform_wxtrans_command',
            buttonName: 'platform_wxtrans_command_buutun',
            categoryId: 'platform',
            businessInfo: {
              command: this.shareCode,
              attributeId: this.attributeId,
              card_guid: this.cardGuid,
              showtype: this.businessType,
            },
          });
          break;
      }
    },

    async init() {
      const { cardGuid, businessType } = this.$route.query;
      this.businessType = businessType;
      this.cardGuid = cardGuid;
      this.attributeId = this.subSceneMap[config.env];

      this.shareCode = this.handleShareCode();

      try {
        const [pageInfo, haCode] = await Promise.all([
          this.getPageInfo(),
          this.getDynamicHaCommand(),
        ]);

        this.showLoading = false;
        this.handlePageInfo(pageInfo);

        // eslint-disable-next-line no-console
        console.log('shareCode', this.shareCode, haCode);
      } catch (error) {
        this.showLoading = false;
        this.showError = true;
      }
    },

    async getPageInfo() {
      try {
        const {
          token, cityCode, adCode, lng, lat,
        } = await getTokenAndLocation();
        let bizType = '';
        switch (this.sceneType) {
          case SCENE_TYPE.STUDENT_CENTER:
            bizType = '1';
            break;
          case SCENE_TYPE.TWO_WHEEL:
            bizType = this.$route.query.businessType || '1';
            break;
          case SCENE_TYPE.SWAP_BATTERY:
            bizType = '';
            break;
          default:
            break;
        }
        const { adsource } = this.$route.query;
        const params = {
          code: 'tiktok_card_page',
          token,
          cityCode,
          adCode,
          lng,
          lat,
          tag: '',
          params: {
            adSource: adsource,
            scene: PAGE_INFO_SCENE[this.sceneType],
            businessType: bizType,
          },
        };
        const {
          data: {
            componentData: {
              data,
            },
          },
        } = await getHaCommandPageInfo(params);
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('getPageInfo error', error);
        throw error;
      }
    },

    handlePageInfo(images) {
      if (Array.isArray(images) && images.length > 0) {
        this.images = images;
      }
    },

    handleShareCode() {
      let baseurl = `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/newClient`;
      const {
        cardGuid, businessType, adsource, batchCode, cardId,
      } = this.$route.query;
      const isExternalCard = this.sceneType === SCENE_TYPE.TWO_WHEEL ? 'true' : 'false';

      switch (this.sceneType) {
        case SCENE_TYPE.TWO_WHEEL:
          baseurl = ParamsUtil.addParams(baseurl, {
            cardGuid,
            businessType,
            isExternalCard,
            adsource,
          });
          break;
        case SCENE_TYPE.STUDENT_CENTER:
          baseurl = ParamsUtil.addParams(baseurl, {
            batchCode,
            adsource,
          });
          break;
        case SCENE_TYPE.SWAP_BATTERY:
          baseurl = `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/t-landing`;
          baseurl = ParamsUtil.addParams(baseurl, {
            cardId,
            adsource,
            batchCode,
          });
          break;
        default:
          break;
      }
      return baseurl;
    },
    async getDynamicHaCommand() {
      const {
        token, cityCode, adCode,
      } = await getTokenAndLocation();
      const { userNewId } = await getTokenAndKey();
      // 获取动态哈口令接口参考文档，https://hellobike.yuque.com/wx01fq/newbie/al6yk24ztbvzt782?singleDoc#
      // 后端负责人：旷黎明
      try {
        const res = await getDynamicHaCommand({
          commandType: '9',
          scene: '22',
          systemCode: getSystemCode(),
          cityCode,
          adCode,
          token,
          userNewId,
          subScene: this.subSceneMap[config.env],
          bizContent: {
            shareCode: this.shareCode,
            sceneSign: this.sceneType,
          },
        });
        if (res.code === 0) {
          this.haCode = res.data.command;
          return res.data.command;
        }
        Toast.show(res.message || '获取哈口令失败');
        return null;
      } catch (error) {
        Toast.show('获取哈口令失败');
        throw error;
      }
    },
    async copyHaCommand() {
      // 上报按钮点击
      this.reportButtonClick();
      if (this.haCode) {
        Toast.show('口令码复制成功，请前往哈啰App使用');
        copyText(this.haCode);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tw-card-active-page {
  background: #e0f7fe;

  .img-peat {
    display: block;
    width: 100%;
    height: auto;
  }

  .button {
    width: 3.5rem;
    height: 0.6rem;
    line-height: 0.6rem;
    font-size: 0.15rem;
    color: #fff;
    background:
      linear-gradient(
        to right,
        #f13e7b,
        #f4573d,
      );
    border-radius: 0.3rem;
    text-align: center;
    position: fixed;
    bottom: 1rem;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
</style>
